import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

/** SCRUM-89: Admin y Lider pueden ver ficha de persona. Contador no. */
export const perfilGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isAdmin() || userStore.isLider()) {
    return true;
  }

  return router.createUrlTree(['/configuracion', 'mi-cuenta']);
};